// @flow
import React from 'react';
import cx from 'classnames';
import { Image } from 'gestalt';

type Props = {|
  color: string,
  image: {
    height: number,
    url: string,
    width: number,
  },
  label: string,
|};

const InterestImage = ({ color, image, label }: Props) => (
  <Image
    alt={label}
    color={color}
    fit="cover"
    naturalHeight={image.height}
    naturalWidth={image.width}
    src={image.url}
  >
    <div className={cx('defaultImageWash')} />
  </Image>
);

export default InterestImage;
